import { useState } from "react";
import {
  SettingsCard,
  SettingsNote,
  SettingsPanel,
  SettingsRow,
  SettingsSelectRow,
  SettingsToggle,
} from "../SettingsUI";

const blockedContacts = [
  { id: "b1", name: "Spam Caller", detail: "+977 980-1112233" },
  { id: "b2", name: "Unknown Ext", detail: "Ext 2099" },
];

export function PrivacySection() {
  const [lastSeen, setLastSeen] = useState("contacts");
  const [profilePhoto, setProfilePhoto] = useState("everyone");
  const [about, setAbout] = useState("contacts");
  const [readReceipts, setReadReceipts] = useState(true);
  const [disappearing, setDisappearing] = useState("off");
  const [groups, setGroups] = useState("contacts");

  return (
    <SettingsPanel title="Privacy" description="Blocked contacts, disappearing messages">
      <SettingsCard title="Who can see my personal info">
        <SettingsSelectRow
          title="Last seen & online"
          description="Control who can see when you were last active"
          value={lastSeen}
          onChange={setLastSeen}
          options={[
            { value: "everyone", label: "Everyone" },
            { value: "contacts", label: "My contacts" },
            { value: "nobody", label: "Nobody" },
          ]}
        />
        <SettingsSelectRow
          title="Profile photo"
          value={profilePhoto}
          onChange={setProfilePhoto}
          options={[
            { value: "everyone", label: "Everyone" },
            { value: "contacts", label: "My contacts" },
            { value: "nobody", label: "Nobody" },
          ]}
        />
        <SettingsSelectRow
          title="About"
          value={about}
          onChange={setAbout}
          options={[
            { value: "everyone", label: "Everyone" },
            { value: "contacts", label: "My contacts" },
            { value: "nobody", label: "Nobody" },
          ]}
        />
        <SettingsToggle
          title="Read receipts"
          description="If turned off, you won’t send or receive read receipts"
          checked={readReceipts}
          onChange={setReadReceipts}
        />
      </SettingsCard>

      <SettingsCard title="Messages">
        <SettingsSelectRow
          title="Default disappearing messages"
          description="New chats start with this timer"
          value={disappearing}
          onChange={setDisappearing}
          options={[
            { value: "off", label: "Off" },
            { value: "24h", label: "24 hours" },
            { value: "7d", label: "7 days" },
            { value: "90d", label: "90 days" },
          ]}
        />
        <SettingsSelectRow
          title="Groups"
          description="Who can add you to groups"
          value={groups}
          onChange={setGroups}
          options={[
            { value: "everyone", label: "Everyone" },
            { value: "contacts", label: "My contacts" },
            { value: "nobody", label: "Nobody" },
          ]}
        />
      </SettingsCard>

      <SettingsCard title="Blocked contacts" description={`${blockedContacts.length} blocked`}>
        {blockedContacts.map((contact) => (
          <SettingsRow
            key={contact.id}
            title={contact.name}
            description={contact.detail}
            trailing={
              <button
                type="button"
                className="rounded-full px-2.5 py-1 text-xs font-semibold text-papaya-deep hover:bg-papaya/10"
              >
                Unblock
              </button>
            }
          />
        ))}
        <SettingsRow title="Add blocked contact" description="Block a number or username" />
      </SettingsCard>

      <SettingsNote>
        Privacy preferences are stored in this browser for the static settings preview.
      </SettingsNote>
    </SettingsPanel>
  );
}
